import{gql as e}from"@apollo/client";import{CONTENT_PAGE_CONTEXT_GRAPHQL as s}from"../../contexts/ContentPageContext/ContentPageContext.graphql.js";const t=e`
  mutation addUserGeneratedCheckboxResponse($contentSnippetId: Int!, $label: String!, $questionResponseSetId: Int!) {
    questionSet {
      addAvailableAnswer(
        isUserGeneratedResponse: true
        responseCheckbox: { contentSnippetId: $contentSnippetId, label: $label, scoreValue: 0, value: "" }
        responseSetId: $questionResponseSetId
      ) {
        availableResponses(fetchUserGeneratedResponses: true) {
          asset {
            ...asset
          }
          id
          label
          ... on QuestionResponseCheckboxType {
            scoreValue
            sort
            userId
          }
          value
        }
        id
      }
    }
  }

  ${s.fragments.asset}
`,n=e`
  mutation addUserGeneratedMatchResponse($contentSnippetId: Int!, $label: String!, $questionResponseSetId: Int!) {
    questionSet {
      addAvailableAnswer(
        isUserGeneratedResponse: true
        responseMatch: { contentSnippetId: $contentSnippetId, label: $label, value: "", startPosition: 0, static: false }
        responseSetId: $questionResponseSetId
      ) {
        availableResponses(fetchUserGeneratedResponses: true) {
          asset {
            ...asset
          }
          id
          label
          ... on QuestionResponseRadioType {
            scoreValue
            sort
            userId
          }
          value
        }
        id
      }
    }
  }

  ${s.fragments.asset}
`,o={Checkbox:t,Radio:e`
  mutation addUserGeneratedRadioResponse($contentSnippetId: Int!, $label: String!, $questionResponseSetId: Int!) {
    questionSet {
      addAvailableAnswer(
        isUserGeneratedResponse: true
        responseRadio: { contentSnippetId: $contentSnippetId, label: $label, scoreValue: 0, value: "" }
        responseSetId: $questionResponseSetId
      ) {
        availableResponses(fetchUserGeneratedResponses: true) {
          asset {
            ...asset
          }
          id
          label
          ... on QuestionResponseRadioType {
            scoreValue
            sort
            userId
          }
          value
        }
        id
      }
    }
  }

  ${s.fragments.asset}
`,Match:n};export{o as QUESTION_CONFIGURATION_TYPE_ADD_USER_GENERATED_RESPONSE_MUTATION_MAP};
//# sourceMappingURL=useAddUserGeneratedResponse.graphql.js.map
